// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HelpText_wrapper__1CnNr","list":"HelpText_list__3cx13","drawerContent":"HelpText_drawerContent__3PPxj","listTitle":"HelpText_listTitle__3rPo9"};